export default { appVersion: ' 2026-11-03 01:00:51 develop' };
